import React from 'react'
/* LIB FUNCTIONS */
import { isPermission } from '../../lib/usePermission'
/* COMPONENTS */
import BPButton from '../BPButton'

const ToolbarButtons = ({ label, tooltip, intent, icon, rightIcon, small, minimal, outlined, onClick, permission, className, disabled, style, buttonRef }) => {
  if (permission && permission !== null) {
    if (isPermission(permission)) {
      return (
        <BPButton type='button' className={className} label={label} tooltip={tooltip} intent={intent} icon={icon} rightIcon={rightIcon} small={small} minimal={minimal} outlined={outlined} disabled={disabled} onClick={onClick} style={style} buttonRef={buttonRef} />
      )
    } else return null
  } else {
    return (
      <BPButton type='button' className={className} label={label} tooltip={tooltip} intent={intent} icon={icon} rightIcon={rightIcon} small={small} minimal={minimal} outlined={outlined} disabled={disabled} onClick={onClick} style={style} buttonRef={buttonRef}/>
    )
  }
}

export default ToolbarButtons
